<div class="pt-2 pt-lg-4">
  @if(showFrom==='companyProfilePage'){
  <dl>
    <dt class="d-none d-md-inline-block">Company Licences and Certificates</dt>
  </dl>
  }@else if (identificationsDataList?.length) {
  <dl>
    <dt class="d-none d-md-inline-block">Credentials</dt>
  </dl>
  }

  <div
    class="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start align-start"
  >
    @if(identificationsDataList?.length){ @for (cred of identificationsDataList;
    track cred) {

    <div
      (click)="['profilePage', 'companyProfilePage', 'subContractorPage'].includes(showFrom)?editCredential(cred):null"
      [ngClass]="['profilePage', 'companyProfilePage', 'subContractorPage'].includes(showFrom)?'license-card cursor-pointer hover':'license-card'"
      [class.expired-licence]="cred?.expiry_code === 2"
    >
      @if (cred?.expiry_code === 2) {
      <div class="fw-bold text-center mb-2">EXPIRED</div>
      }
      <div class="d-flex justify-content-between gap-2">
        <div class="license-header fw-semibold">{{ cred?.id_type }}</div>
        @if (cred?.approval_status == 2 && ['profilePage'].includes(showFrom)) {
        <div class="d-flex column-gap-3 justify-content-end">
          <div
            class="w-100"
            (click)="updateCredentialStatus(cred, 'reject'); $event.stopImmediatePropagation()"
          >
            <i class="fa-solid fs-5 fa-circle-minus text-danger"></i>
          </div>

          <div
            class="w-100"
            (click)="updateCredentialStatus(cred,'approve'); $event.stopImmediatePropagation()"
          >
            <i class="fa-solid fs-5 fa-circle-check text-success"></i>
          </div>
        </div>
        }
      </div>

      <div class="license-body">
        @if(cred?.issuer_state){
        <div class="d-flex align-items-center gap-2">
          <dt>Location</dt>
          <div class="fw-semibold license-data-width text-uppercase">
            {{ cred?.issuer_state }}
          </div>
        </div>
        }
        <div class="d-flex align-items-center gap-2">
          <dt>ID No.</dt>
          <div class="fw-semibold license-data-width">
            {{ cred?.id_number }}
          </div>
        </div>
        @if (cred?.licence_class) {
        <div class="d-flex align-items-center gap-2">
          <dt>Class</dt>
          <div class="fw-semibold license-data-width">
            {{ cred?.licence_class }}
          </div>
        </div>
        } @if (cred?.issue_date) {
        <div class="d-flex align-items-center gap-2">
          <dt>Date of Issue</dt>
          <div class="fw-semibold license-data-width">
            {{ cred?.issue_date | date:'YYY-MM-d' }}
          </div>
        </div>
        }@if (cred?.valid_till) {
        <div class="d-flex align-items-center gap-2">
          <dt>Valid Till</dt>
          <div class="fw-semibold license-data-width">
            {{ cred?.valid_till | date:'YYY-MM-d' }}
          </div>
        </div>
        }
      </div>
    </div>

    } } @if( ['profilePage', 'companyProfilePage',
    'subContractorPage'].includes(showFrom)) {

    <div
      class="position-relative hover-overlay license-card"
      (click)="addNewCred()"
      id="companyLicence"
      role="button"
    >
      <div class="opacity-25 text-secondary">
        <div class="license-header">
          <div class="fw-semibold">SECURITY LICENCE</div>
        </div>

        <div class="license-body">
          <div class="d-flex align-items-center gap-2">
            <dt>Location</dt>
            <div class="fw-semibold text-uppercase">XXXXXX</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <dt>ID No.</dt>
            <div class="fw-semibold">XXXXXXXXXXXXXXXXX</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <dt>Class</dt>
            <div class="fw-semibold">XXXXXXXXX</div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <dt>Valid Till</dt>
            <div class="fw-semibold">YYYY-MM-DD</div>
          </div>
        </div>
      </div>
      <div
        class="fs-5 fw-semibold position-absolute top-50 start-50 translate-middle w-75 text-center"
      >
        + Add
      </div>
    </div>
    }
  </div>
</div>
